export default class VPFR {
    constructor(client) {
        this.client = client
    }

    async request(method, endpoint, params) {
        return await this.client.request({
            method: method,
            url: "/karadjordje/vpfr/" + endpoint,
            ...params
        })
    } 
}